// extracted by mini-css-extract-plugin
module.exports = {"projectBadge":"Badge_projectBadge__cvUTv","badgeIcon":"Badge_badgeIcon__o7pdw","badgeTitle":"Badge_badgeTitle__ZIott","tooltipContent":"Badge_tooltipContent__dA3yr"};